// getFullscreenPopupNotificationContentSize.js
'use strict';
import { getIsOnMobileBySize } from '../resource/getUserAgent.js';
import toEven from '../resource/toEven.js';
import {
  popupNotificationFullscreenContentHorizontalPaddingInDesktop,
  popupNotificationFullscreenContentVerticalPaddingInDesktop,
} from '../style/variables.js';

const isServer = typeof window === 'undefined';

/**
 * Get fullscreen popup notification content size
 * @param {number} {[deviceWidth = 0]} - device width.
 * @param {number} {[deviceHeight = 0]} - device height.
 * @return {Size} content size.
 */
const getFullscreenPopupNotificationContentSize = ({
  deviceWidth = 0,
  deviceHeight = 0,
} = {}) => {
  const isMobile = getIsOnMobileBySize();
  const size = {
    width: 0,
    height: 0,
  };
  if (isServer || [deviceWidth, deviceHeight].includes(0)) {
    return size;
  }
  let contentWidth = 0;
  let contentHeight = 0;
  if (isMobile) {
    contentWidth = deviceWidth;
    contentHeight = deviceHeight;
  } else {
    contentWidth =
      deviceWidth -
      popupNotificationFullscreenContentHorizontalPaddingInDesktop * 2;
    contentHeight =
      deviceHeight -
      popupNotificationFullscreenContentVerticalPaddingInDesktop * 2;
  }
  size.width = toEven({ value: contentWidth });
  size.height = toEven({ value: contentHeight });
  return size;
};

export default getFullscreenPopupNotificationContentSize;
